import styles from './styles.module.scss'
import { CSSTransition } from 'react-transition-group'
import Accordion from '../Accordion'
import { useState } from 'react'

const AccordionGroup = ({ items, max = 9999 }) => {
  if (items) {
    const [openKey, setOpenKey] = useState()

    return (
      <div className={styles.faqs}>
        {items.map(
          (faq, index) =>
            index < max && (
              <CSSTransition
                classNames="opacity"
                appear={true}
                timeout={{ enter: index * 150, exit: index * 150 }}
                key={index}
              >
                <Accordion
                  index={index}
                  openKey={openKey}
                  setOpenKey={setOpenKey}
                  variant={['large']}
                  title={faq.question}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: faq.answer
                    }}
                  ></div>
                </Accordion>
              </CSSTransition>
            )
        )}
      </div>
    )
  }

  return
}

export default AccordionGroup
